module.exports = __webpack_public_path__ + "static/media/cube.8afe0c32.svg";